//export let API_ENDPOINT = "http://localhost/acaps-api/"
export let API_ENDPOINT = "https://api-acaps.intelliesites.com/";

export const API_KEY = process.env.REACT_APP_API_KEY;